
import {Component, Prop, Vue} from "vue-property-decorator";
import CounterpartiesUpdateForm from "@/form/finance/counterparties/CounterpartiesUpdateForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup},
})
export default class CounterpartiesUpdateFormComponent extends Vue {
  @Prop() form!: CounterpartiesUpdateForm;

}
